import { render, staticRenderFns } from "./activity-2.vue?vue&type=template&id=416bc923&scoped=true&"
import script from "./activity-2.vue?vue&type=script&lang=js&"
export * from "./activity-2.vue?vue&type=script&lang=js&"
import style0 from "./activity-2.vue?vue&type=style&index=0&id=416bc923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416bc923",
  null
  
)

export default component.exports